import script from "./LMarker.vue?vue&type=script&lang=js"
export * from "./LMarker.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__